"use client";
import {useEffect, useState} from "react";
import Image from "next/image";
import goomyGif from "@/assets/img/goomy.gif";

const ROTATE_FRAMETIME = 16;
const ROTATE_DELTA = {
  low: 0.003,
  high: 0.005,
};
const ROTATE_SPEEDS = {
  start: 0.01,
  speedup: 1.0,
  panic: 6.0,
};

const Goomy = () => {
  const [rotate, setRotate] = useState(false);
  const [period, setPeriod] = useState(ROTATE_SPEEDS.start);
  const panic = period > ROTATE_SPEEDS.panic;

  const start = () => {
    if (!rotate) {
      setPeriod(ROTATE_SPEEDS.start);
      setRotate(true);
    }
  };

  const stop = () => {
    setRotate(false);
    setPeriod(ROTATE_SPEEDS.start);
  };

  useEffect(() => {
    let timer = null;
    if (rotate) {
      timer = setInterval(() => {
        setPeriod(prev => {
          const increment = prev < ROTATE_SPEEDS.speedup ? "low" : "high";
          return prev + ROTATE_DELTA[increment];
        });
      }, ROTATE_FRAMETIME);
    }
    return () => clearInterval(timer);
  }, [rotate]);

  return (
    <div>
      <figure className={`image is-256x256${rotate ? " rotato" : ""}${panic ? " negative" : ""}`}
              style={{
                animationDuration: `${1.0 / period}s`,
              }}
      >
        <Image priority unoptimized
               alt="All hail our Lord and Savior Goomy!"
               src={goomyGif}
               onClick={start}
        />{" "}
      </figure>{" "}
      <button className={`button is-danger${panic ? "" : " is-hidden"}`}
              onClick={stop}
      >
        Make it stop!
      </button>{" "}
    </div>
  );
};

export default Goomy;
